const SocketEvents = {

    //REPORTS
    ADMIN_REPORT_STATUS_UPDATED: "admin.report.status.updated",
  };
  
  export default SocketEvents;